import React, { useContext } from "react";
import { observer } from "mobx-react";
import { LogOut } from "lucide-react";
import { AppWorkspaceContext } from "../../stores/AppWorkspace";
import { Button, PageHeader, Panel } from "../../../ui";
import AccountInfoCard from "../AccountInfoCard";

const SettingsPage: React.FC = observer(() => {
  const workspace = useContext(AppWorkspaceContext);

  return (
    <div className="mx-auto flex max-w-xl flex-col gap-6">
      <PageHeader title="Settings" subtitle="Account details and session." />

      <AccountInfoCard />

      <Panel>
        <div className="font-semibold">Documentation</div>
        <p className="mt-1 text-sm text-muted">
          Integrate swaps programmatically with HMAC-signed requests.
        </p>
        <a href="/api_docs" className="mt-2 inline-block text-sm">
          API docs →
        </a>
      </Panel>

      <div>
        <Button href="/logout" variant="danger" leftIcon={<LogOut size={16} />}>
          Log out
        </Button>
      </div>

      {workspace.environment && (
        <p className="text-xs text-muted">
          {workspace.environment.data.app_name} · {workspace.environment.data.rails_env}
        </p>
      )}
    </div>
  );
});

export default SettingsPage;
